export enum UrgentConcernTypeEnum {
  GENERAL = "GENERAL",
  BOWEL_MOVEMENT_ALERT = "BOWEL_MOVEMENT_ALERT",
  ADMISSION_REVIEW_ALERT = "ADMISSION_REVIEW_ALERT",
}

export const UrgentConcernTypeLabel: Record<UrgentConcernTypeEnum, string> = {
  [UrgentConcernTypeEnum.GENERAL]: "General",
  [UrgentConcernTypeEnum.BOWEL_MOVEMENT_ALERT]: "Bowel Movement",
  [UrgentConcernTypeEnum.ADMISSION_REVIEW_ALERT]: "Admission Review",
};

export const getUrgentConcernTypeLabel = (
  type?: UrgentConcernTypeEnum | null,
): string | null => {
  if (!type || type === UrgentConcernTypeEnum.GENERAL) {
    return null;
  }
  return UrgentConcernTypeLabel[type];
};
